import { Component, ViewChild, NgZone } from '@angular/core';
import { Nav, Platform, MenuController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HomePage } from '../pages/home/home';
import { NomobilePage } from '../pages/nomobile/nomobile';
import { Storage } from '@ionic/storage';

import { MenuProvider } from '../providers/menu/menu';
import { CommonProvider } from '../providers/common/common';
import { UtilsProvider } from '../providers/utils/utils';
import { PouchdbProvider } from './../providers/pouchdb/pouchdb';

import { TranslateService } from '@ngx-translate/core';
import { Events } from 'ionic-angular';

import { ChangeDetectorRef } from '@angular/core';

import * as L from "leaflet";

// import { DatePipe } from '@angular/common';
// import { SimulationsProvider } from '../providers/simulations/simulations';

// import { FileTransfer } from '@ionic-native/file-transfer'; 
// import { FileTransferObject } from '@ionic-native/file-transfer'; 
// import * as FileWITOIL from '@ionic-native/file'; 


@Component({
    templateUrl: 'app.html',
})



export class Witoil {
    @ViewChild(Nav) nav: Nav;
    
    // private fileTransfer: FileTransferObject; 

    rootPage: any = HomePage;
    pages: any;


    // Pouch
    data: any;
    db: any;
    remote: any;

    languages: any = [
        { "value": "it", "label": "Italiano", "disabled": false, "ico": "../assets/flags/it_IT.png" },
        { "value": "en", "label": "English", "disabled": false, "ico": "../assets/flags/it_IT.png" },
        { "value": "fr", "label": "Français", "disabled": true, "ico": "../assets/flags/it_IT.png" },
        { "value": "es", "label": "Espanol", "disabled": true, "ico": "../assets/flags/it_IT.png" },
        { "value": "es", "label": "...", "disabled": true, "ico": "../assets/flags/it_IT.png" },
        { "value": "es", "label": "...", "disabled": true, "ico": "../assets/flags/it_IT.png" },
    ];
    curr_lang = { "value": "en", "label": "English", "disabled": false }
    langOptions = {
        cssClass: 'flags',
    }

    userDB: any
    mindate: any
    maxdate: any


    // ************* UI ONLY (not in payload) *************
    coordunits: any = [
        { "value": "1", "label": "dms-key", "disabled": false },
        { "value": "2", "label": "dmm-key", "disabled": false },
        { "value": "3", "label": "dd-key", "disabled": false }
    ]

    uncert_displays: any = [
        { "value": "concentration", "label": 'uncert_concentration-key', "disabled": false },
        { "value": "probability", "label": 'uncert_probability-key', "disabled": false }
    ]

    simulations = this.common.simulations


    envFields: any = []
    // envFields: any  = [
    //     { 
    //         "value":"1",
    //         "label":'temperature-key',
    //         "disabled":false,
    //         "layer":'MEDSEA_'+this.common.fcst_date+'_'+this.common.prod_date+'_'+this.common.fcst_time+'_0_Temperature',
    //         "map":'/var/www/html/ov-dev/ov-backend/mapfiles/medfs-dev/MEDSEA_Temperature_'+this.common.prod_date+'.map' 
    //     },
    //     { 
    //         "value":"2",
    //         "label":'wind-key',
    //         "disabled":false,
    //         "layer":"GLO_20200415_20200416_0000_0_Wind,GLO_20200415_20200416_0000_0_Wind-Direction",
    //         "map":"/var/www/html/ov/marine-eo-2/backend/mapfiles/GLO_Wind_20200416.map,/var/www/html/ov/marine-eo-2/backend/mapfiles/GLO_Wind-Direction_20200416.map" 
    //     },
    //     { 
    //         "value":"3",
    //         "label":'wave-height-key',
    //         "disabled":false,
    //         "layer":"MED_${fcst_year}0415_20200416_0000_0_Wave-Height,MED_20200415_20200416_0000_0_Wave-Direction",
    //         "map":"/var/www/html/ov/marine-eo-2/backend/mapfiles/MED_Wave-Height_20200416.map,/var/www/html/ov/marine-eo-2/backend/mapfiles/MED_Wave-Direction_20200416.map" 
    //     },
    //     { 
    //         "value":"4",
    //         "label":'wave-period-key',
    //         "disabled":false,
    //         "layer":"MED_20200415_20200416_0000_0_Wave-Period,MED_20200415_20200416_0000_0_Wave-Direction",
    //         "map":"/var/www/html/ov/marine-eo-2/backend/mapfiles/MED_Wave-Period_20200416.map,/var/www/html/ov/marine-eo-2/backend/mapfiles/MED_Wave-Direction_20200416.map" 
    //     },
    //     { 
    //         "value":"5",
    //         "label":'surfaceCurr-key',
    //         "disabled":false,
    //         "layer":"MEDSEA_20200416_20200417_1300_0_Currents,MEDSEA_20200416_20200417_1300_0_Currents-Direction",
    //         "map":"/var/www/html/ov-dev/ov-backend/mapfiles/medfs-dev/MEDSEA_Currents_20200417.map,/var/www/html/ov-dev/ov-backend/mapfiles/medfs-dev/MEDSEA_Currents-Direction_20200417.map" 
    //     }       
    // ]


    protected curr_coord_unit: any = {}
    protected curr_uncert_display: any = {}
    protected curr_uncert_results: any = {}

    // protected curr_simulation: any = null
    protected curr_env_field: any = {}
    protected curr_env_field_idx: number = 0;

    protected curr_Ov0: any = true
    protected curr_oil0: any


    protected curr_sim_res_totaloil: any
    protected curr_sim_res_beached: any
    public curr_sim_res_env: any

    // *********************** /UI  ****************************







    // *********************** PAYLOAD: BEGIN ****************** 
    protected curr_sim_name: string = ""
    protected curr_notes: string = ""

    protected curr_start_lat: string = ""
    protected curr_start_lon: string = ""
    protected curr_start_latdd: string = ""
    protected curr_start_latmm: string = ""
    protected curr_start_latss: string = ""
    protected curr_start_londd: string = ""
    protected curr_start_lonmm: string = ""
    protected curr_start_lonss: string = ""
    protected curr_start_latdd2: string = ""
    protected curr_start_latmm2: string = ""
    protected curr_start_londd2: string = ""
    protected curr_start_lonmm2: string = ""

    protected curr_oil: any = {}
    protected curr_oiltype: any = {}
    protected curr_model_mode: string = "manual"
    protected curr_model: any = {}
    protected curr_wind: any = {}
    protected curr_UTC_date: any
    protected curr_LOCAL_date: any
    // protected curr_time: any
    protected curr_sim_length: string
    protected curr_plotstep: any = {}

    protected curr_spillType: any
    protected curr_totvolume: string
    protected curr_duration: string
    protected curr_spillrate: string

    protected curr_stokesDrift: any 
    protected curr_windCorrection: any = "1.00"
    protected curr_hDiff: string
    protected curr_oParc: string
    protected curr_eRate: string
    protected curr_dRate: string
    protected curr_tRate: string
    protected curr_owstRate: string

    protected curr_selector: any = {}
    protected curr_uncert_type: any = {}
    protected curr_uncert_position: any = {}

    protected curr_uncert_radius: string


    models = [
        { "value": "MED", "label": 'mfs-cmems-med-key','subtitle':'Regional ocean analysis and forecast system at 1/24 degree covering the Mediterranean Basins. Ocean forecasts are updated daily providing 10 days of 3D ocean fields', "selected": true, "disabled": false },
        { "value": "BLACKSEA", "label": 'blaksea-key','subtitle':'Regional ocean analysis and forecast system at 1/36 x 1/24 degree resolution covering the Black Sea basin. Ocean forecasts are updated daily providing 10 days of 3D ocean fields', "selected": false, "disabled": false },
        { "value": "SANIFS", "label": 'sanifs-key','subtitle':'Local ocean analysis and forecast system for the Southern Adriatic and Northern Ionian Seas area at variable resolution (0.05-3km). Ocean forecasts are updated daily providing 72h of 3D ocean fields', "selected": false, "disabled": false },
        { "value": "GLOB", "label": 'global-key','subtitle':'Global ocean analysis and forecast system at 1/12 degree resolution.  Ocean forecasts are updated daily providing 10 days of 3D ocean fields', "selected": false, "disabled": false },
        { "value": "GOFS", "label": 'gofs-key','subtitle':'GOFS Ocean Forecasting system covering the global area. Ocean forecasts are updated daily with 5 days of 3D ocean fields', "selected": false, "disabled": false },
        { "value": "BALTIC", "label": 'baltic-key','subtitle':'Regional ocean analysis and forecast system at 1NM resolution covering the Baltic Sea basin. Ocean forecasts are updated every 12h providing 6 days of 3D ocean fields', "selected": false, "disabled": false },
        { "value": "IBI", "label": 'ibi-key','subtitle':'IBI Ocean Analysis and Forecasting system at 1/36º horizontal resolution covering the area "Iberian Biscay Irish". Ocean forecasts are updated daily with 5 days of 3D ocean fields', "selected": false, "disabled": false },       
        { "value": "DUBAI", "label": 'dubai-key','subtitle':'Local ocean analysis and forecast system for the Dubai Coastal area at 150m resolution. Ocean forecasts are updated daily providing 5 days of 3D ocean fields', "selected": false, "disabled": false },       
    ]

    winds = [
        { "value": "ECMWF025", "label": "ecmwf025-key", "selected": false, "disabled": false },
        // { "value": "ECMWF05", "label": "ecmwf05-key", "selected": false, "disabled": false },
        // { "value": "COSMO-ME", "label": "cosmo-key", "selected": false, "disabled": false }
    ]

    oils = [
        { "value": "NAME", "label": "TOOname-key", "disabled": false },
        { "value": "API", "label": "TOOapi-key", "disabled": false }
    ]

    oiltypes = []

    plotSteps = [
        { "value": "1", "label": "1", "disabled": false },
        { "value": "3", "label": "3", "disabled": false },
        { "value": "6", "label": "6", "disabled": false },
        { "value": "12", "label": "12", "disabled": false },
        { "value": "24", "label": "24", "disabled": false },
    ]

    spillTypes = [
        { "value": "1", "label": "", "disabled": false },
        { "value": "2", "label": "", "disabled": false }
    ]

    stokesDrifts = [
        { "value": "0", "label": "", "disabled": false },
        { "value": "1", "label": "", "disabled": false }
    ]

    windCorrections = [
        { "value": "0.00", "label": "", "disabled": false },
        { "value": "1.00", "label": "", "disabled": false },
        { "value": "2.00", "label": "", "disabled": false },
        { "value": "3.00", "label": "", "disabled": false }
    ]

    selectors = [
        { "value": "witoil", "label": "none-key", "disabled": false },
        { "value": "uncertainty", "label": "uncertaintyMod-key", "disabled": false },
        { "value": "tactic", "label": "tacticMod-key", "disabled": true },
    ]

    uncert_types = [
        { "value": "position", "label": "uncertPosition-key", "disabled": false },
        { "value": "time", "label": "uncertTime-key", "disabled": true },
    ]

    uncert_positions = [
        { "value": "0", "label": "uncert_position_cross-key", "img": "assets/imgs/cross.png", "disabled": false },
        { "value": "1", "label": "uncert_position_hex-key", "img": "assets/imgs/hex.png", "disabled": false },
    ]




    // curr_oil: any = { "value": "", "label": "", "selected": false };
    // curr_oiltype: any = { 
    //     "Name": "", 
    //     "API":"",
    //     "selected": false 
    // };

    // curr_model: any = { "value":"MYO1h","label":'mfs-cmems-med-key',"disabled":false }
    // curr_wind: any = { "value":"ECMWF025","label":"ecmwf025-key","disabled":false }

    // ************* DEFAULT VALUES: END ************* 


    /* **********************************************************************
    * 
    * 
    *********************************************************************** */
    constructor(
        public platform: Platform,
        public statusBar: StatusBar,
        public splashScreen: SplashScreen,
        public menuProvider: MenuProvider,
        public menuCtrl: MenuController,
        public storage: Storage,
        public common: CommonProvider,
        public utils: UtilsProvider,
        public translate: TranslateService,
        public events: Events,
        private database: PouchdbProvider,
        private zone: NgZone,
        private cdRef: ChangeDetectorRef
        // private datePipe: DatePipe,
        // public simulationsProvider: SimulationsProvider
        // private transfer: FileTransfer, 
        // private file: FileWITOIL
    ) {

        this.platform.ready().then(() => {

            let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            // console.log("isMobile? ",isMobile);

            if (isMobile) this.rootPage = NomobilePage

            events.subscribe('map:clicked', (latlng) => {
                // console.log('Click', latlng);

                // Check Ocean / Land
                this.common.checkLand(latlng).then( response => {
                    let data:any = response
                    data = JSON.parse(data)
                    if(data && data.ocean) {
                        this.common.is_ocean = true
                    } else if(data && !data.ocean)  {
                        this.common.is_ocean = false
                        this.common.showAlert("ERROR!", "Wrong coordinates", "Please, select a point at sea!")
                        return
                    }
                })

                this.setCoords(latlng)
                
                console.log('ModelMode:', this.curr_model_mode);
                if(this.curr_model_mode==='auto') this.getModelFromWS(latlng)
            });

            events.subscribe('marker:drag', (latlng) => {
                // console.log('Drag', latlng);
                this.setCoords(latlng)
            });

            translate.setDefaultLang('en');
            this.setLanguage('en', false)
            // translate.use('en');

            // this.curr_simulation = this.common.curr_simulation

            // ********* GUI, NOT Payload! *********

            // 1. set current array index BEFORE DATE!!!
            this.curr_env_field_idx = 3;
            // 3. set Current date and time
            this.mindate = '2020-11-01'
            this.maxdate = '2020-11-15'
            let date = new Date();
            this.setDate(date, false)

            this.curr_oil0 = true
            this.curr_sim_res_totaloil = true
            this.curr_sim_res_beached = false
            this.curr_sim_res_env = 'nofield'


            // Simulation results
            this.curr_Ov0 = true
            //this.setOv0("true",false);
            // Meteo-oceanografic fileds
            // ???

            this.setUncertResults("true", false)
            this.setUncertDisplay("concentration", false)
            

            // ********* PAYLOAD *********
            this.setOil("NAME");
            this.setModel("MED")
            this.selectWind("ECMWF025")

            this.setCoordUnit("1")
            this.setOil("NAME")

            this.setSimLength("24")
            this.setPlotStep("1")
            this.setSpillType("1")
            this.setTotvolume("1000")
            this.setDuration("24")
            this.setSpillrate("1000")

            this.setStokesDrift("0")
            this.setWindCorrection("1.00", false)
            this.setHDiff("2.0")
            this.setERate("0.000033")
            this.setDRate("0.000008")
            this.setTRate("150")
            this.setOParc("90000")

            this.setSelector("witoil", false)
            this.setUncert_type("position", false)
            this.setUncert_position("0", false)
            this.setUncert_radius("1.8", false)

            // Set values to Payload (request)
            this.setPayload().then((payload) => {
                console.log('payload content: ', payload);
            })

            // DB sync
            this.storage.get("userDB").then((data) => {
                if (data) {
                    this.common.userDB = data;
                } else {
                    this.common.userDB = 'wtldb' + Date.now();
                    this.storage.set("userDB", this.common.userDB)
                }
                this.userDB = this.common.userDB
                let DBurl = this.common.sim_archive_url + "/" + this.common.userDB;
                this.database.sync(DBurl);
            })

            // Change listener
            this.database.getChangeListener().subscribe(data => {
                // console.log("getChangeListener", data)
                this.getSimulations();
                for (let i = 0; i < data.change.docs.length; i++) {
                    this.zone.run(() => {
                        // this.common.simulations.push(data.change.docs[i]);
                        // console.log("getChangeListener:", data.change.docs[i], this.common.simulations)
                        let sim_id = data.change.docs[i].sim_id
                        let status = data.change.docs[i].status
                        let status_message = data.change.docs[i].status_message
                        let rev = data.change.docs[i]._rev

                        this.common.simulations.forEach(archived_sim => {
                            if (status != 'pending' && sim_id == archived_sim.sim_id && rev != archived_sim._rev) {
                                let msg = 'Simulation with ID ' + sim_id + ' completed with status ' + status.toUpperCase() + ' ' + status_message + '.<br/>'
                                if (status != 'failure') msg += 'Please, click the icon in the "COMPUTED SIMULATIONS" box.'
                                let title = status != 'failure' ? "Simulation ready" : "Simulation failed"
                                this.common.showAlert(title, 'ID: '+sim_id, msg)
                            }
                        });

                    });
                }
            });

            this.getSimulations();

        })

    }


    /* **********************************************************************
    * 
    * 
    *********************************************************************** */
    private getModelFromWS(latlng) {
        console.log("getModelFromWS", latlng)
        this.common.getModelFromWS(latlng).then( (model:string) => {
            // alert(model)
            this.setModel(model)
        })
    
    }
    
    
    
    /* **********************************************************************
    * 
    * 
    *********************************************************************** */
    public getSimulations() {
        this.database.fetch().then(result => {
            // console.log("fetch", result)
            this.common.simulations = [];
            for (let i = 0; i < result.rows.length; i++) {
                result.rows[i].doc.payload.sim_length = Number(result.rows[i].doc.payload.sim_length);
                result.rows[i].doc.payload.duration = Number(result.rows[i].doc.payload.duration);
                // result.rows[i].doc.notified = false
                this.common.simulations.push(result.rows[i].doc);
                // console.log("result.rows[i].doc", result.rows[i].doc)
            }
            // console.log("FETCH:   ", this.common.simulations);
        }, error => {
            console.error('getSimulations: ', error);
        });
    }


    /* **********************************************************************
    * 
    * 
    *********************************************************************** */

    public ionViewDidEnter() {


    }

    /* **********************************************************************
    * 
    * 
    *********************************************************************** */
    ionViewDidLoad() {

    }


    /* ***********************************************************************
     * 
     *  setPayload() - Set defaul values to request payload Payload
     * 
    *********************************************************************** */
    setPayload() {

        return new Promise(resolve => {

            this.platform.ready().then(() => {

                this.common.payload = {
                    "sim_name": "",
                    "notes": "",
                    "start_lat": this.curr_start_lat,
                    "start_lon": this.curr_start_lon,
                    "model": this.curr_model.value,
                    "wind": this.curr_wind.value,
                    "sim_length": this.common.pad(this.curr_sim_length, 4, 0),

                    "year": this.common.pad(new Date(this.curr_UTC_date).getUTCFullYear().toString().slice(2, 4), 2, 0),
                    "month": this.common.pad((new Date(this.curr_UTC_date).getUTCMonth() + 1).toString(), 2, 0),
                    "day": this.common.pad(new Date(this.curr_UTC_date).getUTCDate().toString(), 2, 0),
                    "hour": this.common.pad(new Date(this.curr_UTC_date).getUTCHours().toString(), 2, 0),
                    "minutes": this.common.pad(new Date(this.curr_UTC_date).getUTCMinutes().toString(), 2, 0),

                    "lat_degree": this.common.pad(this.curr_start_latdd2, 2, 0),
                    "lat_minutes": this.curr_start_latmm2,
                    "lon_degree": this.common.pad(this.curr_start_londd2, 2, 0),
                    "lon_minutes": this.curr_start_lonmm2,
                    "spillType": parseInt(this.curr_spillType.value),
                    "duration": this.common.pad(this.curr_duration, 4, 0),
                    "spillrate": this.curr_spillrate,
                    "oil": this.curr_oil.value,
                    "oiltype": this.curr_oiltype.value,
                    "var_02": this.curr_stokesDrift.value,      // Stokes drift
                    "var_03": this.curr_windCorrection.value,   // Slider wind correction
                    "var_10": this.curr_hDiff,                  // hDiff
                    "var_14": this.curr_oParc,                  // oParc
                    "var_19": this.curr_eRate,                  // eRate
                    "var_29": this.curr_dRate,                  // dRate
                    "var_39": this.curr_tRate,                  // tRate
                    "plotStep": parseInt(this.curr_plotstep.value),
                    "selector": this.curr_selector.value,
                    "uncert_type": this.curr_selector.value !== 'witoil' ? this.curr_uncert_type.value : '',
                    "hex": this.curr_selector.value !== 'witoil' ? this.curr_uncert_position.value : '',
                    "uncert_radius": this.curr_selector.value !== 'witoil' ? this.curr_uncert_radius : '',
                }

                this.storage.set("payload", this.common.payload)
                resolve(this.common.payload)
                // return (this.common.payload)
            });
        });
    }


    /* ***********************************************************************
     * 
     *  Initialize
     * 
     *********************************************************************** */
    initializeApp() {
        this.platform.ready().then(() => {
            console.log("*** initializeApp ***");
            this.statusBar.styleDefault();
            this.splashScreen.hide();
        });
    }

    /* ********************************************************************************************
     * 
     *  oil -> Payload
     * 
     * ********************************************************************************************/
    setOil(oil: string) {
        // console.log("setOil: ", oil)

        // 1. set curr_oil
        let found = this.oils.filter(function (item) { return item.value === oil });
        this.curr_oil = found[0]
        this.common.payload.oil = this.curr_oil.value

        // 2. set curr_oil_type and populates OilTypes combo
        switch (oil) {
            case "NAME":
                this.common.getOilsByName().then((oiltypes: any) => {
                    this.oiltypes = oiltypes
                    this.curr_oiltype = this.oiltypes[0]
                    this.common.payload.oiltype = this.curr_oiltype.Name;
                    // console.log("case NAME this.common.payload.oiltype: ", this.common.payload.oiltype)
                })
                break
            case "API":
                this.common.getOilsByAPI().then((oiltypes: any) => {
                    this.oiltypes = oiltypes
                    this.curr_oiltype = this.oiltypes[0]
                    this.common.payload.oiltype = this.curr_oiltype.API
                    // console.log("case API this.common.payload.oiltype: ", this.common.payload.oiltype)
                })
                break
            default:
                this.oiltypes = []
        }
    }

    /* ********************************************************************************************
     * 
     *  oiltype -> Payload
     * 
     * ********************************************************************************************/
    setOilType(oiltype: string) {
        console.log("setOilType: ", this.curr_oil, oiltype)
        let found = this.oiltypes.filter(function (item) { return item.Name === oiltype });
        this.curr_oiltype = found[0]
        console.log("*** this.curr_oiltype ", this.curr_oiltype)
        if(this.curr_oil.value=='NAME') this.common.payload.oiltype = this.curr_oiltype.Name
        else if(this.curr_oil.value=='API') this.common.payload.oiltype = this.curr_oiltype.API
        console.log("Payload oiltype: ", this.common.payload.oiltype)

    }

    /* ********************************************************************************************
     * 
     *  model mode
     * 
     * ********************************************************************************************/

    setModelMode(mode: string) {
        // to be implemented
        this.curr_model_mode = mode
    }
    
    /* ********************************************************************************************
     * 
     *  model -> Payload
     * 
     * ********************************************************************************************/
    setModel(model: string) {
        // console.log("model--> ", model)
        let found = this.models.filter(function (item) { return item.value === model });
        this.curr_model = found[0]
        this.common.payload.model = this.curr_model.value

        // console.log("Payload model: ", this.common.payload.model)

        let tmpmindate: any
        let tmpmaxdate: any
        switch (this.common.payload.model) {
            case 'GLOB':
                tmpmindate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
                tmpmindate.setUTCHours(13, 0, 0, 0)
                tmpmaxdate = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)
                tmpmaxdate.setUTCHours(12, -1, 0, 0)
                // Set HORIZONTAL DIFFUSIVITY
                this.setHDiff("10.0")
                break
            case 'GOFS':
                tmpmindate = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)
                tmpmindate.setUTCHours(13, 0, 0, 0)
                tmpmaxdate = new Date(Date.now() + 5 * 24 * 60 * 60 * 1000)
                tmpmaxdate.setUTCHours(12, -1, 0, 0)
                // Set HORIZONTAL DIFFUSIVITY
                this.setHDiff("10.0")
                break                
            case 'SANIFS':
                tmpmindate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
                tmpmindate.setUTCHours(13, 0, 0, 0)
                tmpmaxdate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000)
                tmpmaxdate.setUTCHours(0, -1, 0, 0)
                // Set HORIZONTAL DIFFUSIVITY
                this.setHDiff("0.2")
                break
            case 'BLACKSEA':
                tmpmindate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
                tmpmindate.setUTCHours(13, 0, 0, 0)
                tmpmaxdate = new Date(Date.now() + 2 * 24 * 60 * 60 * 1000)
                tmpmaxdate.setUTCHours(0, -1, 0, 0)
                // Set HORIZONTAL DIFFUSIVITY
                this.setHDiff("2.0")
                break
            case 'MED':
                // tmpmindate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
                tmpmindate = new Date(Date.now() - 20 * 24 * 60 * 60 * 1000)
                tmpmindate.setUTCHours(13, 0, 0, 0)
                tmpmaxdate = new Date(Date.now() + 2 * 24 * 60 * 60 * 1000)
                tmpmaxdate.setUTCHours(0, -1, 0, 0)
                // Set HORIZONTAL DIFFUSIVITY
                this.setHDiff("2.0")
                break
            case 'BALTIC':
                tmpmindate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
                tmpmindate.setUTCHours(13, 0, 0, 0)
                tmpmaxdate = new Date(Date.now() + 2 * 24 * 60 * 60 * 1000)
                tmpmaxdate.setUTCHours(0, -1, 0, 0)
                // Set HORIZONTAL DIFFUSIVITY
                this.setHDiff("2.0")
                break                
            case 'IBI':
                tmpmindate = new Date(Date.now() - 15 * 24 * 60 * 60 * 1000)
                tmpmindate.setUTCHours(13, 0, 0, 0)
                tmpmaxdate = new Date(Date.now() + 4 * 24 * 60 * 60 * 1000)
                tmpmaxdate.setUTCHours(0, -1, 0, 0)
                // Set HORIZONTAL DIFFUSIVITY
                this.setHDiff("2.0")
                break
            case 'DUBAI':
                tmpmindate = new Date(Date.now() - 15 * 24 * 60 * 60 * 1000)
                tmpmindate.setUTCHours(13, 0, 0, 0)
                tmpmaxdate = new Date(Date.now() + 5 * 24 * 60 * 60 * 1000)
                tmpmaxdate.setUTCHours(0, -1, 0, 0)
                // Set HORIZONTAL DIFFUSIVITY
                this.setHDiff("2.0")
                break   
            default:
                break
        }
        // this.mindate = '2020-11-01'
        this.mindate = tmpmindate.toISOString()
        this.maxdate = tmpmaxdate.toISOString()
        console.log("Model: " + this.common.payload.model +  " - this.mindate    --->   ", this.mindate)
        console.log("Model: " + this.common.payload.model +  " - this.maxdate    --->   ", this.maxdate)


        // $("#datetimepicker").data("datetimepicker").setDate(new Date(2020,12,12));
    }

    /* ********************************************************************************************
     * 
     *  wind -> Payload
     * 
     * ********************************************************************************************/
    selectWind(wind: string) {
        // console.log("wind--> ", wind)
        let found = this.winds.filter(function (item) { return item.value === wind });
        this.curr_wind = found[0]
        this.common.payload.wind = this.curr_wind.value
        // console.log("Payload wind: ", this.common.payload.wind)
    }

    /* ********************************************************************************************
     * 
     *  NON interessa il payload
     * 
     * ********************************************************************************************/
    setCoordUnit(unit: string) {
        // console.log("unit--> ", unit)
        let found = this.coordunits.filter(function (item) { return item.value === unit });
        this.curr_coord_unit = found[0]
        // console.log("this.curr_coord_unit: ", this.curr_coord_unit)
        // this.convertCoordinates()
    }

    /* ********************************************************************************************
     * 
     *   interessa il payload
     * 
     * ********************************************************************************************/
    setCoords(coords: any) {
        // console.log("setCoords---> ", coords)
       
        coords = L.latLng(coords);
        let ret = []

        // 1. DD
        this.curr_start_lat = coords.lat.toFixed(5)
        this.curr_start_lon = coords.lng.toFixed(5)
        // DMS
        ret = this.utils.dd2dms(
            this.curr_start_lat,
            this.curr_start_lon
        )
        this.curr_start_latdd = ret[0]
        this.curr_start_latmm = ret[1]
        this.curr_start_latss = ret[2]
        this.curr_start_londd = ret[3]
        this.curr_start_lonmm = ret[4]
        this.curr_start_lonss = ret[5]
        // 2. DMM
        ret = this.utils.dd2dmm(
            this.curr_start_lat,
            this.curr_start_lon
        )
        this.curr_start_latdd2 = ret[0]
        this.curr_start_latmm2 = ret[1]
        this.curr_start_londd2 = ret[3]
        this.curr_start_lonmm2 = ret[4]

        // 3. SET PAYLOAD
        this.common.payload.start_lat = this.curr_start_lat
        this.common.payload.start_lon = this.curr_start_lon
        this.common.payload.lat_degree = this.curr_start_latdd2
        this.common.payload.lat_minutes = this.curr_start_latmm2
        this.common.payload.lon_degree = this.curr_start_londd2
        this.common.payload.lon_minutes = this.curr_start_lonmm2
    }


    /* ********************************************************************************************
     * 
     *  (day,month,year,hour,minutes) -> Payload
     * 
     * ********************************************************************************************/
    setDate(date: any, gui: boolean = true) {

        // let curr_date: any

        if (gui) {
            this.common.curr_date = new Date(date.year, date.month - 1, date.day, date.hour, date.minute, 0, 0)
            console.log("setDate GUI --> ", this.common.curr_date)
            this.curr_UTC_date = this.common.curr_date.toISOString();
            // this.curr_LOCAL_date -->
            // NON SETTARE PERCHè invoca onchange sul datepicker e chiamate cicliche a questo metodo
        } else {
            this.common.curr_date = new Date(date.getTime())
            console.log("setDate NOT GUI --> ", this.common.curr_date)
            this.curr_UTC_date = this.common.curr_date.toISOString();
            this.curr_LOCAL_date = new Date(this.common.curr_date.getTime() - (this.common.curr_date.getTimezoneOffset() * 60000)).toISOString()
        }

        this.common.payload.year = this.common.pad(this.common.curr_date.getUTCFullYear().toString().slice(2, 4), 2, 0);
        this.common.payload.month = this.common.pad((this.common.curr_date.getUTCMonth() + 1).toString(), 2, 0);
        this.common.payload.day = this.common.pad(this.common.curr_date.getUTCDate().toString(), 2, 0);
        this.common.payload.hour = this.common.curr_date.getUTCHours().toString();
        this.common.payload.minutes = this.common.pad(this.common.curr_date.getUTCMinutes().toString(), 2, 0);

        // "year": this.common.pad( new Date(this.curr_UTC_date).getUTCFullYear().toString().slice(2,4), 2 ,0 ), 
        // "month": this.common.pad( (new Date(this.curr_UTC_date).getUTCMonth() + 1).toString(), 2, 0 ),
        // "day": this.common.pad( new Date(this.curr_UTC_date).getUTCDate().toString(), 2, 0),
        // "hour": this.common.pad( new Date(this.curr_UTC_date).getUTCHours().toString(), 2, 0 ),
        // "minutes": this.common.pad( new Date(this.curr_UTC_date).getUTCMinutes().toString(), 2, 0 ),

        console.log("this.curr_UTC_date ", this.curr_UTC_date);        // UTC TIME
        console.log("this.curr_LOCAL_date ", this.curr_LOCAL_date);    // LOCAL TIME
        console.log("this.common.payload --> ", this.common.payload)


        this.curr_env_field = this.common.env_fields_array[0]
        this.setEnvfield(this.curr_env_field, false)
        
        // 2. set Env field array
        // this.common.set_env_fields_array(this.common.curr_date).then(data => {

        //     this.envFields = data;
        //     // console.log("this.envFields   ", this.envFields)

        //     // 4. set current field
        //     this.common.set_curr_env_field(this.curr_env_field_idx).then(data => {
        //         this.curr_env_field = data
        //         this.setEnvfield(this.curr_env_field, false)
        //     })

        // });


    }

    /* ********************************************************************************************
     * 
     *  
     * 
     * ********************************************************************************************/
    setSimLength(sim_length: any) {
        // console.log("setSimLength --> ", sim_length)
        // let found = this.plotSteps.filter(function(item) { return item.value === plotstep });
        this.cdRef.detectChanges();
        this.curr_sim_length = sim_length.length > 3 ? sim_length.substring(0,3) : sim_length;
        this.common.payload.sim_length = this.common.pad(this.curr_sim_length, 4, 0);
        console.log("this.common.payload --> ", this.common.payload.sim_length)
    }

    /* ********************************************************************************************
     * 
     *  
     * 
     * ********************************************************************************************/
    setPlotStep(plotstep: any) {
        console.log("selectPlotStep --> ", plotstep)
        let found = this.plotSteps.filter(function (item) { return item.value === plotstep });
        this.curr_plotstep = found[0]
        console.log("*** this.curr_plotstep --> ", this.curr_plotstep)
        this.common.payload.plotStep = this.curr_plotstep.value;
        // console.log("this.common.payload --> ", this.common.payload)
    }

    /* ********************************************************************************************
     * 
     *  
     * 
     * ********************************************************************************************/
    setSpillType(spillType: any) {
        console.log("setSpillType --> ", spillType)
        
        let found = this.spillTypes.filter(function (item) { return item.value === spillType });
        this.curr_spillType = found[0]
        console.log("*** curr_spillType --> ", this.curr_spillType)
        // NB: in caso di spillType==1 (Instantaneous) spillrate===totvolume
        if(this.curr_spillType.value==="1") {
            // this.setSpillrate(this.curr_totvolume)
            this.common.payload.spillrate = this.common.pad(this.curr_totvolume, 4, 0);
        } else if(this.curr_spillType.value==="2") {
            // this.setSpillrate(this.curr_spillrate)
            this.common.payload.spillrate = this.common.pad(this.curr_spillrate, 4, 0);
        }
        this.common.payload.spillType = this.curr_spillType.value;
        console.log("this.common.payload --> ", this.common.payload.spillrate)
    }

    /* ********************************************************************************************
     * 
     *  
     * 
     * ********************************************************************************************/
    setTotvolume(totvolume: any) {
        console.log("setTotvolume --> ", totvolume)
        this.cdRef.detectChanges();
        this.curr_totvolume = totvolume.length > 4 ? totvolume.substring(0,4) : totvolume;
        console.log("*** curr_totvolume --> ", this.curr_totvolume)
        // NB: nel caso di spillType== --> spillrate = curr_totvolume
        this.common.payload.spillrate = this.common.pad(this.curr_totvolume, 4, 0)
        console.log("this.common.payload --> ", this.common.payload.spillrate)
        // this.common.pad(, 4, 0)
    }

    /* ********************************************************************************************
     * 
     *  
     * 
     * ********************************************************************************************/
    setDuration(duration: any) {
        // console.log("setDuration --> ", duration)
        this.cdRef.detectChanges();
        this.curr_duration = duration.length > 3 ? duration.substring(0,3) : duration;
        console.log("*** curr_duration --> ", this.curr_duration)
        this.common.payload.duration = this.common.pad(this.curr_duration, 4, 0);
        console.log("this.common.payload --> ", this.common.payload.duration)
    }

    /* ********************************************************************************************
     * 
     *  
     * 
     * ********************************************************************************************/
    setSpillrate(spillrate: any) {
        console.log("setSpillrate --> ", spillrate)
        this.cdRef.detectChanges();
        this.curr_spillrate = spillrate.length > 4 ? spillrate.substring(0,4) : spillrate;
        // console.log("*** curr_spillrate --> ", this.curr_spillrate)
        this.common.payload.spillrate = this.common.pad(this.curr_spillrate, 4, 0);
        console.log("this.common.payload --> ", this.common.payload.spillrate)
    }

    /* ********************************************************************************************
     * 
     *  var_02 === stokesDrifts
     * 
     * ********************************************************************************************/
    setStokesDrift(stokesDrift: any) {
        console.log("setStokesDrift --> ", stokesDrift)
        let found = this.stokesDrifts.filter(function (item) { return item.value === stokesDrift })
        this.curr_stokesDrift = found[0]
        // console.log("*** curr_stokesDrift --> ", this.curr_stokesDrift)
        this.common.payload.var_02 = this.curr_stokesDrift.value
        // console.log("this.common.payload --> ", this.common.payload)
    }

    /* ********************************************************************************************
     * 
     *  var_03 === windCorrection
     * 
     * ********************************************************************************************/
    setWindCorrection(windCorrection: any, gui: boolean = true) {
        let val: string
        if (gui) val = (Math.round(windCorrection._value * 100) / 100).toFixed(2)
        else val = (Math.round(windCorrection * 100) / 100).toFixed(2)
        // console.log("setWindCorrection --> ", val, gui )
        let found = this.windCorrections.filter(function (item) { return item.value === val.toString() })
        this.curr_windCorrection = found[0]
        // console.log("*** curr_windCorrection --> ", this.curr_windCorrection)
        this.common.payload.var_03 = this.curr_windCorrection.value
        // console.log("this.common.payload --> ", this.common.payload)
    }

    /* ********************************************************************************************
     * 
     *  var_10 === hDiff
     * 
     * ********************************************************************************************/
    setHDiff(hdiff: any) {
        // console.log("setHDiff --> ", hdiff)
        this.curr_hDiff = hdiff
        this.common.payload.var_10 = this.curr_hDiff
        // console.log("this.common.payload --> ", this.common.payload)
    }

    /* ********************************************************************************************
     * 
     *  var_14 === oParc
     * 
     * ********************************************************************************************/
    setOParc(oParc: any) {
        // console.log("setOParc --> ", oParc)
        this.curr_oParc = oParc
        this.common.payload.var_14 = this.curr_oParc
        // console.log("this.common.payload --> ", this.common.payload)
    }

    /* ********************************************************************************************
     * 
     *  var_19 === eRate
     * 
     * ********************************************************************************************/
    setERate(eRate: any) {
        // console.log("setERate --> ", eRate)
        this.curr_eRate = eRate
        this.common.payload.var_19 = this.curr_eRate
        // console.log("this.common.payload --> ", this.common.payload)
    }

    /* ********************************************************************************************
     * 
     *  var_29 === dRate
     * 
     * ********************************************************************************************/
    setDRate(dRate: any) {
        // console.log("setDRate --> ", dRate)
        this.curr_dRate = dRate
        this.common.payload.var_29 = this.curr_dRate
        // console.log("this.common.payload --> ", this.common.payload)
    }

    /* ********************************************************************************************
     * 
     *  var_39 === tRate
     * 
     * ********************************************************************************************/
    setTRate(tRate: any) {
        // console.log("setTRate --> ", tRate)
        this.curr_tRate = tRate
        this.common.payload.var_39 = this.curr_tRate
        // console.log("this.common.payload --> ", this.common.payload)
    }

    /* ********************************************************************************************
     * 
     *  
     * 
     * ********************************************************************************************/
    setSelector(selector: any, gui: boolean = true) {
        let val: string
        if (gui) val = selector.value
        else val = selector
        let found = this.selectors.filter(function (item) { return item.value === val })
        this.curr_selector = found[0]
        // console.log("*** curr_selector --> ", this.curr_selector)
        this.common.payload.selector = this.curr_selector.value
        // Uncert_type, Uncert_radius
        if (this.curr_selector.value == 'uncertainty') {
            this.setUncert_type("position", false)
            this.setUncert_position("0", false)
            this.setUncert_radius("1.8", false)
        }
        // console.log("this.common.payload --> ", this.common.payload)
    }

    /* ********************************************************************************************
     * 
     *  
     * 
     * ********************************************************************************************/
    setUncert_type(uncert_type: any, gui: boolean = true) {
        let val: string
        if (gui) val = uncert_type.value
        else val = uncert_type
        let found = this.uncert_types.filter(function (item) { return item.value === val })
        this.curr_uncert_type = found[0]
        // console.log("*** curr_uncert_type --> ", this.curr_uncert_type)
        this.common.payload.uncert_type = this.curr_uncert_type.value
        // console.log("this.common.payload --> ", this.common.payload)
    }

    /* ********************************************************************************************
     * 
     *  
     * 
     * ********************************************************************************************/
    setUncert_position(uncert_position: any, gui: boolean = true) {
        // console.log("*** setUncert_position --> ", uncert_position)
        let val: string
        if (gui) val = uncert_position.value
        else val = uncert_position
        let found = this.uncert_positions.filter(function (item) { return item.value === val })
        this.curr_uncert_position = found[0]
        // console.log("*** curr_uncert_position --> ", this.curr_uncert_position)
        this.common.payload.hex = this.curr_uncert_position.value
        // console.log("this.common.payload --> ", this.common.payload)
    }

    /* ********************************************************************************************
     * 
     *  
     * 
     * ********************************************************************************************/
    setUncert_radius(uncert_radius: any, gui: boolean = true) {
        // console.log("*** setUncert_radius --> ", uncert_radius)
        this.curr_uncert_radius = uncert_radius
        this.common.payload.uncert_radius = this.curr_uncert_radius
        // console.log("this.common.payload --> ", this.common.payload)       
    }


    /* ********************************************************************************************
     * 
     *  NON interessa il payload
     * 
     * ********************************************************************************************/
    setUncertResults(uncert_results: any, gui: boolean = true) {

        let val: string
        if (gui) val = uncert_results._value
        else val = uncert_results
        // console.log("*** setUncertResults --> ", val)
        this.curr_uncert_results = val
        // console.log("*** curr_uncert_results --> ", this.curr_uncert_results)
    }


    /* ********************************************************************************************
     * 
     *  NON interessa il payload
     * 
     * ********************************************************************************************/
    setUncertDisplay(uncert_display: any, gui: boolean = true) {
        // console.log("*** setUncertDisplay --> ", uncert_display)
        let val: string
        if (gui) val = uncert_display.value
        else val = uncert_display
        let found = this.uncert_displays.filter(function (item) { return item.value === val })
        this.curr_uncert_display = found[0]
        // console.log("*** curr_uncert_display --> ", this.curr_uncert_display)
    }


    /* ********************************************************************************************
     * 
     *  NON interessa il payload
     * 
     * ********************************************************************************************/
    setOv0(ov0: any, gui: boolean = true) {
        console.log("*** setOv0 --> ", ov0)
        let val: string
        if (gui) val = ov0._value
        else val = ov0
        this.curr_Ov0 = val
        // console.log("*** curr_Ov0 --> ", this.curr_Ov0, this.curr_env_field)
        if (this.curr_Ov0 == false) this.setEnvfield(null, false)
        else this.setEnvfield(this.curr_env_field, false)
    }

    /* ********************************************************************************************
    * 
    *  NON interessa il payload
    * 
    * ********************************************************************************************/
    setOil0(oil0: any) {
        console.log("*** setOil0 --> ", oil0)
        this.curr_oil0 = oil0
        this.common.visualization_options.curr_oil0 = oil0;
        if(this.curr_oil0) this.showSim(this.common.curr_simulation)
        else {
            if (this.common.player && this.common.player.isPlaying()) {
                this.common.player.stop();
            }
            if (this.common.simulationLayer) this.common.map.removeLayer(this.common.simulationLayer);
            if (this.common.simulationTimeLayer) this.common.map.removeLayer(this.common.simulationTimeLayer);
            if (this.common.timeDimensionControl) this.common.map.removeControl(this.common.timeDimensionControl);
            if (this.common.map.timeDimension) this.common.map.timeDimension = null;
        }
    }

    /* ********************************************************************************************
    * 
    *  NON interessa il payload
    * 
    * ********************************************************************************************/
    setSimOilRes(elem: any, val: any) {
        // console.log("**** setSimOilRes: ", elem, val);
        if (elem == 'sim_res_totaloil') this.common.visualization_options.curr_sim_res_totaloil = val
        if (elem == 'sim_res_beached') this.common.visualization_options.curr_sim_res_beached = val
        this.showSim(this.common.curr_simulation)
    }

    /* ********************************************************************************************
    * 
    *  NON interessa il payload
    * 
    * ********************************************************************************************/
    setSimEnvRes(elem: any) {
        // console.log("**** setSimEnvRes: ", elem);
        this.common.visualization_options.curr_sim_res_env = elem
        this.showSim(this.common.curr_simulation)
    }

    /* ********************************************************************************************
     * 
     *  NON interessa il payload
     * 
     * ********************************************************************************************/
    setEnvfield(env_field: any, gui: boolean = true) {
        // console.log("*** setEnvfield --> ", env_field)

        if (env_field) {
            let val: string
            if (gui) val = env_field
            else val = env_field.value

            let found = this.envFields.filter(function (item) { return item.value === val })

            // console.log("*** this.curr_env_field_idx --> ", this.curr_env_field_idx)
            this.curr_env_field_idx = parseInt(val)
            // console.log("*** this.curr_env_field_idx --> ", this.curr_env_field_idx)

            this.common.curr_env_field = found[0]
            this.curr_env_field = this.common.curr_env_field

            // console.log("*** curr_env_field --> ", this.common.curr_env_field)
            this.events.publish('map:setlayer', this.common.curr_env_field.layer, this.common.curr_env_field.map);
        } else {
            this.events.publish('map:setlayer', null, null);
        }
    }

    /* ********************************************************************************************
     * 
     *  NON interessa il payload
     * 
     * ********************************************************************************************/
    // setEnvfieldIdx(idx: number = 0) {
    //     console.log("*** setEnvfieldIdx --> ", idx)
    //     console.log("*** envFields --> ", this.envFields)
    //     // let found = this.envFields.filter(function(item) { return item.value === env_field })
    //     // this.common.curr_env_field = found[0]
    //     // console.log("*** curr_env_field --> ", this.common.curr_env_field)
    //     // this.events.publish('map:setlayer', this.common.curr_env_field.layer,this.common.curr_env_field.map);
    // }

    /* ********************************************************************************************
     * 
     *  NON interessa il payload
     * 
     * ********************************************************************************************/
    showSim(sim: any, zoom:boolean = false) {
    
        

        console.log("*** showSim --> ", this.curr_oil0, sim)
        
        //  this.setOil0(true)
        // if(!this.curr_oil0) return;
        
        // if (this.common.curr_simulation && sim.sim_id === this.common.curr_simulation.sim_id) {
        //     console.log("rimuovere layer")
        //     if (this.common.simulationLayer) this.common.map.removeLayer(this.common.simulationLayer);
        //     if (this.common.simulationTimeLayer) this.common.map.removeLayer(this.common.simulationTimeLayer);
        //     if (this.common.timeDimensionControl) this.common.map.removeControl(this.common.timeDimensionControl);
        //     if (this.common.map.timeDimension) this.common.map.timeDimension = null;
            
        //     this.common.simulationLayer = null;
        //     this.common.simulationTimeLayer = null;
        //     this.common.timeDimensionControl = null;
        //     this.common.colorbarEnvUrl = null
        //     this.common.colorbarOilUrl = null
        //     return;
        // }

        // console.log("*** showSim --> ", sim.sim_id, this.common.curr_simulation?.sim_id)

        // "sim_name": "", ok
        // "notes": "", ok
        // "start_lat": "", ok
        // "start_lon": "", ok
        // "model": "", ok
        // "wind": [], ok
        // "sim_length": "", ok
        // "day": "",
        // "month": "",
        // "year": "",
        // "hour": "",
        // "minutes": "",
        // "lat_degree": "", ok
        // "lat_minutes": "", ok
        // "lon_degree": "", ok
        // "lon_minutes": "", ok
        // "spillType": 0,
        // "duration": "0001",
        // "spillrate": "",
        // "oil": [],
        // "oiltype": [],
        // "var_02": "",    StokesDrift
        // "var_03": "",    WindCorrection
        // "var_10": "",    hDiff
        // "var_14": "",    oParc
        // "var_19": "",    eRate
        // "var_29": "",    dRate
        // "var_39": "",    tRate
        // "plotStep": 0,
        // "selector": "",
        // "uncert_type": "",
        // "hex": "",
        // "uncert_radius": "",

        this.common.curr_simulation = sim
        this.events.publish('map:setSimulationLayers', this.common.curr_simulation, zoom, this.curr_oil0);

        // set Simulation values in the GUI
        let payload = sim.payload
        this.common.payload.sim_name = payload.sim_name     // scrivere SETTER
        this.common.payload.notes = payload.notes           // scrivere SETTER
        let coords = { 'lat': parseFloat(payload.start_lat), 'lng': parseFloat(payload.start_lon) }
        this.setCoords(coords)
        this.setModel(payload.model)
        this.selectWind(payload.wind)
        this.setSimLength(payload.sim_length)     // scrivere SETTER
        this.setSpillType(payload.spillType)
        this.setDuration(payload.duration)
        this.setSpillrate(payload.spillrate)
        this.setStokesDrift(payload.var_02)
        this.setWindCorrection(payload.var_03, false)
        this.setHDiff(payload.var_10)
        this.setOParc(payload.var_14)
        this.setERate(payload.var_19)
        this.setDRate(payload.var_29)
        this.setTRate(payload.var_39)
        this.setSelector(payload.selector, false)
        if (payload.uncert_type) this.setUncert_type(payload.uncert_type, false)
        if (payload.hex) this.setUncert_position(payload.hex, false)
        if (payload.uncert_radius) this.setUncert_radius(payload.uncert_radius, false)
        
    }
    
 
    /* ********************************************************************************************
     * 
     *  Set latitude DD
     * 
     * ********************************************************************************************/
    set_lat($event) {
        console.log("set_lat", this.curr_coord_unit.value, $event.target.value, $event);
        this.curr_start_lat = $event.target.value
        this.convertCoordinates()

        if ($event.keyCode == 13) {
            console.log("set_lat: ", $event.target.value, $event)

            if (this.validLat(this.curr_start_lat)) {
                if (this.validLon(this.curr_start_lon)) {
                    // this.common.setMarker({ 'lat': this.curr_start_lat, 'lng': this.curr_start_lon })
                    let coords = { 'lat': this.curr_start_lat, 'lng': this.curr_start_lon }
                    this.common.setMarker(coords)
                    this.setCoords(coords)
                    this.common.map.panTo([this.curr_start_lat, this.curr_start_lon])
                }
            } else {
                this.common.showAlert("ERROR", "Wrong latitude", "Insert a valid Latitude!")
            }
        }
    }

    /* ********************************************************************************************
     * 
     * Set longitude DD
     * 
     * ********************************************************************************************/
    set_lon($event) {
        console.log("set_lon", $event);
        this.curr_start_lon = $event.target.value
        this.convertCoordinates()

        if ($event.keyCode == 13) {
            console.log("set_lon: ", $event.target.value, $event)

            if (this.validLon(this.curr_start_lon)) {
                if (this.validLat(this.curr_start_lat)) {
                    // this.common.setMarker({ 'lat': this.curr_start_lat, 'lng': this.curr_start_lon })
                    // this.common.map.panTo([this.curr_start_lat, this.curr_start_lon])
                    let coords = { 'lat': this.curr_start_lat, 'lng': this.curr_start_lon }
                    this.common.setMarker(coords)
                    this.setCoords(coords)
                    this.common.map.panTo([this.curr_start_lat, this.curr_start_lon])
                }
            } else {
                this.common.showAlert("ERROR", "Wrong longitude", "Insert a valid Longitude!")
            }
        }

    }

    /* ********************************************************************************************
     * 
     *  Set latitude dd DMS
     * 
     * ********************************************************************************************/
    set_lat_dd($event) {
        console.log("set_lat_dd", $event);
        this.curr_start_latdd = $event.target.value
        this.convertCoordinates()

        if ($event.keyCode == 13) {
            console.log("set_lat_dd: ", $event.target.value, $event)

            if (this.validLat(this.curr_start_lat)) {
                if (this.validLon(this.curr_start_lon)) {
                    // this.common.setMarker({ 'lat': this.curr_start_lat, 'lng': this.curr_start_lon })
                    // this.common.map.panTo([this.curr_start_lat, this.curr_start_lon])
                    let coords = { 'lat': this.curr_start_lat, 'lng': this.curr_start_lon }
                    this.common.setMarker(coords)
                    this.setCoords(coords)
                    this.common.map.panTo([this.curr_start_lat, this.curr_start_lon])
                }
            } else {
                this.common.showAlert("ERROR", "Wrong latitude", "Insert a valid Latitude!")
            }
        }

    }
    /* ********************************************************************************************
     * 
     *  Set latitude mm DMS
     * 
     * ********************************************************************************************/
    set_lat_mm($event) {
        console.log("set_lat_mm", $event);
        this.curr_start_latmm = $event.target.value
        this.convertCoordinates()

        if ($event.keyCode == 13) {
            console.log("set_lat_mm: ", $event.target.value, $event)

            if (this.validLat(this.curr_start_lat)) {
                if (this.validLon(this.curr_start_lon)) {
                    // this.common.setMarker({ 'lat': this.curr_start_lat, 'lng': this.curr_start_lon })
                    // this.common.map.panTo([this.curr_start_lat, this.curr_start_lon])
                    let coords = { 'lat': this.curr_start_lat, 'lng': this.curr_start_lon }
                    this.common.setMarker(coords)
                    this.setCoords(coords)
                    this.common.map.panTo([this.curr_start_lat, this.curr_start_lon])
                }
            } else {
                this.common.showAlert("ERROR", "Wrong latitude", "Insert a valid Latitude!")
            }
        }
    }
    /* ********************************************************************************************
    * 
    *  Set latitude ss DMS
    * 
    * ********************************************************************************************/
    set_lat_ss($event) {
        console.log("set_lat_ss", $event);
        this.curr_start_latss = $event.target.value
        this.convertCoordinates()

        if ($event.keyCode == 13) {
            console.log("set_lat_ss: ", $event.target.value, $event)

            if (this.validLat(this.curr_start_lat)) {
                if (this.validLon(this.curr_start_lon)) {
                    // this.common.setMarker({ 'lat': this.curr_start_lat, 'lng': this.curr_start_lon })
                    // this.common.map.panTo([this.curr_start_lat, this.curr_start_lon])
                    let coords = { 'lat': this.curr_start_lat, 'lng': this.curr_start_lon }
                    this.common.setMarker(coords)
                    this.setCoords(coords)
                    this.common.map.panTo([this.curr_start_lat, this.curr_start_lon])
                }
            } else {
                this.common.showAlert("ERROR", "Wrong latitude", "Insert a valid Latitude!")
            }
        }
    }
    /* ********************************************************************************************
   * 
   *  Set longitude dd DMS
   * 
   * ********************************************************************************************/
    set_lon_dd($event) {
        console.log("set_lon_dd", $event);
        this.curr_start_londd = $event.target.value
        this.convertCoordinates()

        if ($event.keyCode == 13) {
            console.log("set_lon_dd: ", $event.target.value, $event)

            if (this.validLon(this.curr_start_lon)) {
                if (this.validLat(this.curr_start_lat)) {
                    // this.common.setMarker({ 'lat': this.curr_start_lat, 'lng': this.curr_start_lon })
                    // this.common.map.panTo([this.curr_start_lat, this.curr_start_lon])
                    let coords = { 'lat': this.curr_start_lat, 'lng': this.curr_start_lon }
                    this.common.setMarker(coords)
                    this.setCoords(coords)
                    this.common.map.panTo([this.curr_start_lat, this.curr_start_lon])
                }
            } else {
                this.common.showAlert("ERROR", "Wrong longitude", "Insert a valid Longitude!")
            }
        }
    }
    /* ********************************************************************************************
     * 
     *  Set longitude mm DMS
     * 
     * ********************************************************************************************/
    set_lon_mm($event) {
        console.log("set_lon_mm", $event);
        this.curr_start_lonmm = $event.target.value
        this.convertCoordinates()

        if ($event.keyCode == 13) {
            console.log("set_lon_mm: ", $event.target.value, $event)

            if (this.validLon(this.curr_start_lon)) {
                if (this.validLat(this.curr_start_lat)) {
                    // this.common.setMarker({ 'lat': this.curr_start_lat, 'lng': this.curr_start_lon })
                    // this.common.map.panTo([this.curr_start_lat, this.curr_start_lon])
                    let coords = { 'lat': this.curr_start_lat, 'lng': this.curr_start_lon }
                    this.common.setMarker(coords)
                    this.setCoords(coords)
                    this.common.map.panTo([this.curr_start_lat, this.curr_start_lon])
                }
            } else {
                this.common.showAlert("ERROR", "Wrong longitude", "Insert a valid Longitude!")
            }
        }
    }
    /* ********************************************************************************************
     * 
     *  Set longitude ss DMS
     * 
     * ********************************************************************************************/
    set_lon_ss($event) {
        console.log("set_lon_ss", $event);
        this.curr_start_lonss = $event.target.value
        this.convertCoordinates()

        if ($event.keyCode == 13) {
            console.log("set_lon_ss: ", $event.target.value, $event)

            if (this.validLon(this.curr_start_lon)) {
                if (this.validLat(this.curr_start_lat)) {
                    // this.common.setMarker({ 'lat': this.curr_start_lat, 'lng': this.curr_start_lon })
                    // this.common.map.panTo([this.curr_start_lat, this.curr_start_lon])
                    let coords = { 'lat': this.curr_start_lat, 'lng': this.curr_start_lon }
                    this.common.setMarker(coords)
                    this.setCoords(coords)
                    this.common.map.panTo([this.curr_start_lat, this.curr_start_lon])
                }
            } else {
                this.common.showAlert("ERROR", "Wrong longitude", "Insert a valid Longitude!")
            }
        }
    }

    /* ********************************************************************************************
     * 
     *  Set latitude dd DMM
     * 
     * ********************************************************************************************/
    set_lat_dd2($event) {
        console.log("set_lat_dd2", $event);
        this.curr_start_latdd2 = $event.target.value
        this.convertCoordinates()

        if ($event.keyCode == 13) {
            console.log("set_lat_dd2: ", $event.target.value, $event)

            if (this.validLat(this.curr_start_lat)) {
                if (this.validLon(this.curr_start_lon)) {
                    // this.common.setMarker({ 'lat': this.curr_start_lat, 'lng': this.curr_start_lon })
                    // this.common.map.panTo([this.curr_start_lat, this.curr_start_lon])
                    let coords = { 'lat': this.curr_start_lat, 'lng': this.curr_start_lon }
                    this.common.setMarker(coords)
                    this.setCoords(coords)
                    this.common.map.panTo([this.curr_start_lat, this.curr_start_lon])
                }
            } else {
                this.common.showAlert("ERROR", "Wrong latitude", "Insert a valid Latitude!")
            }
        }
    }
    /* ********************************************************************************************
     * 
     *  Set latitude mm DMM
     * 
     * ********************************************************************************************/
    set_lat_mm2($event) {
        console.log("set_lat_mm2", $event);
        this.curr_start_latmm2 = $event.target.value
        this.convertCoordinates()

        if ($event.keyCode == 13) {
            console.log("set_lat_mm2: ", $event.target.value, $event)

            if (this.validLat(this.curr_start_lat)) {
                if (this.validLon(this.curr_start_lon)) {
                    // this.common.setMarker({ 'lat': this.curr_start_lat, 'lng': this.curr_start_lon })
                    // this.common.map.panTo([this.curr_start_lat, this.curr_start_lon])
                    let coords = { 'lat': this.curr_start_lat, 'lng': this.curr_start_lon }
                    this.common.setMarker(coords)
                    this.setCoords(coords)
                    this.common.map.panTo([this.curr_start_lat, this.curr_start_lon])
                }
            } else {
                this.common.showAlert("ERROR", "Wrong latitude", "Insert a valid Latitude!")
            }
        }
    }
    /* ********************************************************************************************
  * 
  *  Set longitude dd DMM
  * 
  * ********************************************************************************************/
    set_lon_dd2($event) {
        console.log("set_lon_dd2", $event);
        this.curr_start_londd2 = $event.target.value
        this.convertCoordinates()

        if ($event.keyCode == 13) {
            console.log("set_lon_dd2: ", $event.target.value, $event)

            if (this.validLon(this.curr_start_lon)) {
                if (this.validLat(this.curr_start_lat)) {
                    // this.common.setMarker({ 'lat': this.curr_start_lat, 'lng': this.curr_start_lon })
                    // this.common.map.panTo([this.curr_start_lat, this.curr_start_lon])
                    let coords = { 'lat': this.curr_start_lat, 'lng': this.curr_start_lon }
                    this.common.setMarker(coords)
                    this.setCoords(coords)
                    this.common.map.panTo([this.curr_start_lat, this.curr_start_lon])
                }
            } else {
                this.common.showAlert("ERROR", "Wrong longitude", "Insert a valid Longitude!")
            }
        }
    }
    /* ********************************************************************************************
     * 
     *  Set longitude mm DMM
     * 
     * ********************************************************************************************/
    set_lon_mm2($event) {
        console.log("set_lon_mm2", $event);
        this.curr_start_lonmm2 = $event.target.value
        this.convertCoordinates()

        if ($event.keyCode == 13) {
            console.log("set_lon_mm2: ", $event.target.value, $event)

            if (this.validLon(this.curr_start_lon)) {
                if (this.validLat(this.curr_start_lat)) {
                    // this.common.setMarker({ 'lat': this.curr_start_lat, 'lng': this.curr_start_lon })
                    // this.common.map.panTo([this.curr_start_lat, this.curr_start_lon])
                    let coords = { 'lat': this.curr_start_lat, 'lng': this.curr_start_lon }
                    this.common.setMarker(coords)
                    this.setCoords(coords)
                    this.common.map.panTo([this.curr_start_lat, this.curr_start_lon])
                }
            } else {
                this.common.showAlert("ERROR", "Wrong longitude", "Insert a valid Longitude!")
            }
        }
    }

    /* ********************************************************************************************
     * 
     * 
     * 
     * ********************************************************************************************/
    validLat(lat) {
        let ret = false
        lat = parseFloat(lat)
        let valid_lat = lat != '' && isFinite(lat) && Math.abs(lat) <= 90;
        if (valid_lat) ret = true
        return ret
    }
    /* ********************************************************************************************
 * 
 * 
 * 
 * ********************************************************************************************/
    validLon(lon) {
        let ret = false
        lon = parseFloat(lon)
        let valid_lon = lon != '' && isFinite(lon) && Math.abs(lon) <= 180;
        if (valid_lon) ret = true
        return ret
    }



    /*------------------------------------------------------------
     * Coordinates conversion
     *------------------------------------------------------------*/
    convertCoordinates() {

        let ret = new Array();

        console.log("convertCoordinates", this.curr_coord_unit)

        switch (this.curr_coord_unit.value) {
            case "1":
                console.log("Current Unit = DMS, convert to DMM, DD")
                // convert DMS to DMM
                ret = this.utils.dms2dmm(
                    this.curr_start_latdd,
                    this.curr_start_latmm,
                    this.curr_start_latss,
                    this.curr_start_londd,
                    this.curr_start_lonmm,
                    this.curr_start_lonss
                )
                this.curr_start_latdd2 = ret[0];
                this.curr_start_latmm2 = ret[1];
                this.curr_start_londd2 = ret[3];
                this.curr_start_lonmm2 = ret[4];

                // convert DMS to DD
                ret = this.utils.dms2dd(
                    this.curr_start_latdd,
                    this.curr_start_latmm,
                    this.curr_start_latss,
                    this.curr_start_londd,
                    this.curr_start_lonmm,
                    this.curr_start_lonss
                );
                this.curr_start_lat = ret[0].toFixed(5);
                this.curr_start_lon = ret[1].toFixed(5);
                break

            case "2":
                console.log("Current Unit = DMM, convert to DMS, DD")
                // convert DMM to DMS
                ret = this.utils.dmm2dms(
                    this.curr_start_latdd2,
                    this.curr_start_latmm2,
                    this.curr_start_londd2,
                    this.curr_start_lonmm2
                )
                console.log("dmm2dms----> ", ret);
                this.curr_start_latdd = ret[0]
                this.curr_start_latmm = ret[1]
                this.curr_start_latss = ret[2]
                this.curr_start_londd = ret[3]
                this.curr_start_lonmm = ret[4]
                this.curr_start_lonss = ret[5]
                // convert DMM to DD
                ret = this.utils.dmm2dd(
                    this.curr_start_latdd2,
                    this.curr_start_latmm2,
                    this.curr_start_londd2,
                    this.curr_start_lonmm2
                )
                console.log("dmm2dd----> ", ret);
                this.curr_start_lat = ret[0];
                this.curr_start_lon = ret[1];
                break
            case "3":
                console.log("Current Unit = DD, convert to DMS, DMM")
                // convert DD to DMS
                ret = this.utils.dd2dms(this.curr_start_lat, this.curr_start_lon);
                this.curr_start_latdd = ret[0];
                this.curr_start_latmm = ret[1];
                this.curr_start_latss = ret[2];
                this.curr_start_londd = ret[3];
                this.curr_start_lonmm = ret[4];
                this.curr_start_lonss = ret[5];
                // convert DD to DMM
                ret = this.utils.dd2dmm(this.curr_start_lat, this.curr_start_lon);
                this.curr_start_latdd2 = this.common.pad(ret[0], 2, 0)
                this.curr_start_latmm2 = ret[1]
                this.curr_start_londd2 = this.common.pad(ret[3], 2, 0)
                this.curr_start_lonmm2 = ret[4]
                break

        }

    }


    /*------------------------------------------------------------
     * 
     *------------------------------------------------------------*/

    checkDMSfields() {
        // return ($("#start_latdd").val().trim() == '' || $("#start_latmm").val().trim()=='' || $("#start_latss").val().trim()=='' || $("#start_londd").val().trim()=='' || $("#start_lonmm").val().trim()=='' || $("#start_lonss").val().trim()=='');
    }

    /*------------------------------------------------------------
     *  
     *------------------------------------------------------------*/
    checkDMMfields() {
        // return ($("#start_latdd2").val().trim() == '' || $("#start_latmm2").val().trim()=='' || $("#start_londd2").val().trim()=='' || $("#start_lonmm2").val().trim()=='');
    }

    fillDDfields(ddflag) {
        // if (ddflag == 1) 	{
        // 	ret = new Array();
        // 	ret=dms2dd($("#start_latdd").val(),$("#start_latmm").val(),$("#start_latss").val(),$("#start_londd").val(),$("#start_lonmm").val(),$("#start_lonss").val());
        // 	var lat = ret[0].toFixed(5);
        // 	var lon = ret[1].toFixed(5);
        // 	$("#start_lat").val(lat);
        // 	$("#start_lon").val(lon);
        // }
        // else if (ddflag == 2) 	{
        // 	ret = new Array();
        // 	ret=dmm2dd($("#start_latdd2").val(),$("#start_latmm2").val(),$("#start_londd2").val(),$("#start_lonmm2").val());
        // 	var lat = ret[0].toFixed(5);
        // 	var lon = ret[1].toFixed(5);
        // 	$("#start_lat").val(lat);
        // 	$("#start_lon").val(lon);
        // }
    }


    /*------------------------------------------------------------
     * Coordinates validation
     *------------------------------------------------------------*/
    validateCoordinates() {
        // var type = $("input[name='coordunit']:checked").val();
        // var valid = true;

        // switch (type) {
        // case "1": // DMS
        //    	if (false === isFloat($("#start_latdd").val()) ||
        // 			false === isFloat($("#start_latmm").val()) ||
        // 			false === isFloat($("#start_latss").val()) ||
        // 			false === isFloat($("#start_londd").val()) ||
        // 			false === isFloat($("#start_lonmm").val()) ||
        // 			false === isFloat($("#start_lonss").val()) ) {
        //    	valid = false;
        //    	}
        // case "2": // DMM
        // 	if (false === isFloat($("#start_latdd2").val()) || 
        // 			false === isFloat($("#start_latmm2").val()) || 
        // 			false === isFloat($("#start_latdd2").val()) || 
        // 			false === isFloat($("#start_latmm2").val()) || 
        // 			false === isFloat($("#start_londd2").val()) || 
        // 			false === isFloat($("#start_lonmm2").val()) ) {
        //    	valid = false;
        // 	}
        // case "3": // DD
        // 	if (false === isFloat($("#start_lat").val()) || 
        // 	    false === isFloat($("#start_lon").val())) {
        //    	valid = false;
        // 	}
        // }

        // if (valid) {
        // 	$("#position").css("border",'');
        // 	return true;
        // }
        // else {
        // 	$("#position").css("border",'2px solid red');
        // 	showErrorMsg('\u0050\u006c\u0065\u0061\u0073\u0065\u0020\u0069\u006e\u0073\u0065\u0072\u0074\u0020\u006f\u006e\u006c\u0079\u0020\u006e\u0075\u006d\u0062\u0065\u0072\u0073')
        // 	return false;
        // }
    }



    /*------------------------------------------------------------
    * 
    *------------------------------------------------------------*/
    // dd2dms(coordlat, coordlon) {

    //     let retVal = new Array();

    //     let ddLat = coordlat.toString();
    //     ddLat.replace(",", ".");

    //     let ddLong = coordlon.toString();
    //     ddLong.replace(",", ".");

    //     if (ddLat.indexOf('.') == -1) ddLat += ".0";
    //     if (ddLat.indexOf('.') == ddLat.length - 1) ddLat += "0";
    //     if (ddLong.indexOf('.') == -1) ddLong += ".0";
    //     if (ddLong.indexOf('.') == ddLong.length - 1) ddLong += "0";

    //     let ddLatVal = ddLat;
    //     let ddLongVal = ddLong;

    //     // degrees = degrees
    //     let ddLatVals = ddLatVal.split(".");
    //     let dmsLatDeg = ddLatVals[0];

    //     let ddLongVals = ddLongVal.split(".");
    //     let dmsLongDeg = ddLongVals[0];

    //     // * 60 = mins
    //     // let ddLatRemainder  = ("0." + ddLatVals[1]) * 60;
    //     let ddLatRemainder = +("0." + ddLatVals[1]) * 60;

    //     let dmsLatMinVals = ddLatRemainder.toString().split(".");
    //     // let dmsLatMin = dmsLatMinVals[0];
    //     let dmsLatMin = +dmsLatMinVals[0];
    //     if (dmsLatMinVals.length == 1) dmsLatMinVals[1] = "0";

    //     // let ddLongRemainder = ("0." + ddLongVals[1]) * 60;
    //     let ddLongRemainder = +("0." + ddLongVals[1]) * 60;

    //     let dmsLongMinVals = ddLongRemainder.toString().split(".");
    //     // let dmsLongMin = dmsLongMinVals[0];
    //     let dmsLongMin = +dmsLongMinVals[0];
    //     // if (dmsLongMinVals.length == 1) dmsLongMinVals[1]=0;
    //     if (dmsLongMinVals.length == 1) dmsLongMinVals[1] = "0";

    //     // * 60 again = secs
    //     // let ddLatMinRemainder = ("0." + dmsLatMinVals[1]) * 60;
    //     let ddLatMinRemainder = +("0." + dmsLatMinVals[1]) * 60;
    //     let dmsLatSec = Math.round(ddLatMinRemainder);
    //     let secLatDiv = dmsLatSec / 60;
    //     dmsLatSec = dmsLatSec % 60;
    //     secLatDiv = Math.floor(secLatDiv);
    //     if (secLatDiv) {
    //         dmsLatMin++;
    //         let minLatDiv = dmsLatMin / 60;
    //         minLatDiv = Math.floor(minLatDiv);
    //         dmsLatMin = dmsLatMin % 60;
    //         if (minLatDiv) dmsLatDeg++;
    //     }

    //     // let ddLongMinRemainder = ("0." + dmsLongMinVals[1]) * 60;
    //     let ddLongMinRemainder = +("0." + dmsLongMinVals[1]) * 60;
    //     let dmsLongSec = Math.round(ddLongMinRemainder);
    //     let secLongDiv = dmsLongSec / 60;
    //     dmsLongSec = dmsLongSec % 60;
    //     secLongDiv = Math.floor(secLongDiv);
    //     if (secLongDiv) {
    //         dmsLongMin++;
    //         let minLongDiv = dmsLongMin / 60;
    //         minLongDiv = Math.floor(minLongDiv);
    //         dmsLongMin = dmsLongMin % 60;
    //         if (minLongDiv) dmsLongDeg++;
    //     }

    //     retVal[0] = dmsLatDeg; 		// Lat degrees
    //     retVal[1] = dmsLatMin;  	// Lat mins
    //     retVal[2] = dmsLatSec;  	// Lat secs
    //     retVal[3] = dmsLongDeg;		// Lon degrees
    //     retVal[4] = dmsLongMin;  	// Lon mins
    //     retVal[5] = dmsLongSec;  	// Lon secs

    //     return (retVal);
    // }





    // /*------------------------------------------------------------
    // * 
    // *------------------------------------------------------------*/
    // dd2dmm(coordlat, coordlon) {

    //     let retVal = new Array();

    //     let ddLat = coordlat.toString();
    //     ddLat.replace(",", ".");

    //     let ddLong = coordlon.toString();
    //     ddLong.replace(",", ".");

    //     if (ddLat.indexOf('.') == -1)
    //         ddLat += ".0";

    //     if (ddLat.indexOf('.') == ddLat.length - 1)
    //         ddLat += "0";

    //     if (ddLong.indexOf('.') == -1)
    //         ddLong += ".0";

    //     if (ddLong.indexOf('.') == ddLong.length - 1)
    //         ddLong += "0";

    //     // degrees = degrees
    //     let ddLatVals = ddLat.split(".");
    //     let dmsLatDeg = ddLatVals[0];

    //     let ddLongVals = ddLong.split(".");
    //     let dmsLongDeg = ddLongVals[0];

    //     // * 60 = mins
    //     let dmsLatMin = +("0." + ddLatVals[1]) * 60;
    //     let dmsLongMin = +("0." + ddLongVals[1]) * 60;

    //     retVal[0] = dmsLatDeg; 		// Lat degrees
    //     retVal[1] = dmsLatMin.toFixed(5);  	// Lat mins
    //     //retVal[2] = dmsLatSec;  	// Lat secs

    //     retVal[3] = dmsLongDeg;		// Lon degrees
    //     retVal[4] = dmsLongMin.toFixed(5);  	// Lon mins
    //     //retVal[5] = dmsLongSec;  	// Lon secs

    //     return (retVal);
    // }


    /*
   dms2dd(dmsLatDeg, dmsLatMin, dmsLatSec, dmsLongDeg, dmsLongMin, dmsLongSec)
   {
       retVal = new Array();
       // find decimal latitude
       ddLatVal = dmsLatDeg*1 + dmsLatMin/60 + dmsLatSec/3600;
       //ddLatVal = dmsLatHem.options[dmsLatHem.selectedIndex].value + ddLatVal;
   	
       // find decimal longitude
       ddLongVal = dmsLongDeg*1 + dmsLongMin/60 + dmsLongSec/3600;
       //ddLongVal = dmsLongHem.options[dmsLongHem.selectedIndex].value + ddLongVal;
   	
       // write values
       retVal[0] = ddLatVal;
       retVal[1] = ddLongVal;
   	
       return (retVal);
   }
	
   dmm2dd(dmmLatDeg, dmmLatMin, dmmLongDeg, dmmLongMin)
   {
       retVal = new Array();
       // find decimal latitude
       ddLatVal = dmmLatDeg*1 + dmmLatMin/60;
       //ddLatVal = dmsLatHem.options[dmsLatHem.selectedIndex].value + ddLatVal;
   	
       // find decimal longitude
       ddLongVal = dmmLongDeg*1 + dmmLongMin/60;
       //ddLongVal = dmsLongHem.options[dmsLongHem.selectedIndex].value + ddLongVal;
   	
       // write values
       retVal[0] = ddLatVal;
       retVal[1] = ddLongVal;
   	
       return (retVal);
   }
	
   dmmLatDeg, dmmLatMin, dmmLongDeg, dmmLongMin)
   {
       retVal = new Array();
   	
       // degrees = degrees
       dmsLatDeg = dmmLatDeg;
       dmsLongDeg = dmmLongDeg;
   	
       ddLat = dmmLatMin.toString();
       ddLat.replace(",", ".");
   	
       ddLong = dmmLongMin.toString();
       ddLong.replace(",", ".");
   	
       if (ddLat.indexOf('.') == -1)
           ddLat+=".0";
   	
       if (ddLat.indexOf('.') == ddLat.length-1)
           ddLat+="0";
   	
       if (ddLong.indexOf('.') == -1)
           ddLong+=".0";
   	
       if (ddLong.indexOf('.') == ddLong.length-1)
           ddLong+="0";
   	
       ddLatVal = ddLat;
       ddLongVal = ddLong;
   	
       ddLatVals = ddLatVal.split(".");
       dmsLatMin = ddLatVals[0];
   	
       ddLongVals = ddLongVal.split(".");
       dmsLongMin = ddLongVals[0];
   	
       // * 60 = mins
       ddLatRemainder  = ("0." + ddLatVals[1]) * 60;
       dmsLatSec = Math.round(ddLatRemainder);
       secLatDiv = dmsLatSec / 60;
       dmsLatSec = dmsLatSec % 60;
       secLatDiv = Math.floor(secLatDiv);
       if (secLatDiv)
       {
           dmsLatMin++;
           minLatDiv = dmsLatMin / 60;
           minLatDiv = Math.floor(minLatDiv);
           dmsLatMin = dmsLatMin % 60;
           if (minLatDiv) dmsLatDeg++;
       }
   	
       ddLongRemainder  = ("0." + ddLongVals[1]) * 60;
       dmsLongSec = Math.round(ddLongRemainder);
       secLongDiv = dmsLongSec / 60;
       dmsLongSec = dmsLongSec % 60;
       secLongDiv = Math.floor(secLongDiv);
       if (secLongDiv)
       {
           dmsLongMin++;
           minLongDiv = dmsLongMin / 60;
           minLongDiv = Math.floor(minLongDiv);
           dmsLongMin = dmsLongMin % 60;
           if (minLongDiv) dmsLongDeg++;
       }
   	
       retVal[0] = dmsLatDeg; 		// Lat degrees
       retVal[1] = dmsLatMin;  	// Lat mins
       retVal[2] = dmsLatSec;  	// Lat secs
       retVal[3] = dmsLongDeg;		// Lon degrees
       retVal[4] = dmsLongMin;  	// Lon mins
       retVal[5] = dmsLongSec;  	// Lon secs
   	
       return (retVal);
   }
	
   function dms2dmm(dmsLatDeg, dmsLatMin, dmsLatSec, dmsLongDeg, dmsLongMin, dmsLongSec)
   {
       retVal = new Array();
   	
       // degrees = degrees
       dmmLatDeg = dmsLatDeg;
       dmmLongDeg = dmsLongDeg;
   	
       dmmLatMin = dmsLatMin*1 + dmsLatSec/60;
       dmmLongMin = dmsLongMin*1 + dmsLongSec/60;
   	
       // write values
       retVal[0] = dmmLatDeg; 		// Lat degrees
       retVal[1] = dmmLatMin.toFixed(5);  	// Lat mins
   	
       retVal[3] = dmmLongDeg;		// Lon degrees
       retVal[4] = dmmLongMin.toFixed(5);  	// Lon mins
   	
       return (retVal);
   }
	
   round100000(v) {
       return Math.round(v * 100000) / 100000;
   }
	

*/

















    // oilsByName: any = []


    /*---------------------------------------------------------------
     * fill input fields
     *---------------------------------------------------------------*/
    /*
    
    // General parameters
    $("#txtTitle").val(req['sim_name'].replace(/_/g,' '));
	
    // workaround per consentire il caricamento delle precedenti simulazioni 
    // che ancora non contegono il campo "notes"
    if (req['notes'] != undefined) 
        $("#notes").val(req['notes'].replace(/_/g,' '));
    else 
        $("#notes").val("");
	
//	$("#start_lat").val(req['start_lat']);
//	$("#start_lon").val(req['start_lon']);
	
    updateCoordsFields(req['start_lat'], req['start_lon']);
	
    //$("#res_current").val(req['res_current']);
    //$("#currentDepth").val(req['depth']);
    //$("#res_wind").val(req['res_wind']);

    // Type of oil
    $("#oil").selectpicker('val',req['oil']);
	
    var oilTypeTimer = setInterval(function() {
        $("#oiltype").val(req['oiltype']);
        if (oilTypeLoaded) {
            clearInterval(oilTypeTimer);
            $("#oiltype").selectpicker('refresh');
//			$("#oiltype").selectpicker("refresh");
        }
    },200);
	
	
	
    // Forecasting system
    // NOT USED YET
    // req['model']
    // req['wind']
	
    // Time
    var reqDate = new Date("20"+req['year']+"-"+req['month']+"-"+req['day']+"T"+req['hour']+":"+req['minutes']);
    //console.log("20"+req['year']+"-"+req['month']+"-"+req['day']+"T"+req['hour']+":"+req['minutes']);
    //console.log("R:   ",reqDate.toString());
    $("#datetimepicker").data("datetimepicker").setDate(new Date(reqDate));
	
    $('#sim_length').val(parseInt(req['sim_length']));
    nStep = parseInt($('#sim_length').val());
    console.log("R:   ",req['sim_length']);
	
    var plotStep = parseInt(req['plotStep']);
    $('#plotStep').selectpicker('val',plotStep);
	
    timeStepHrs = parseInt(req['plotStep']);


    // Type of spill
    $('input:radio[name=spillType]').val([req['spillType']]);
    if(req['spillType']=='1'){
        $('#duration,#spillrate').prop('disabled',true);
        //$("#duration").val('0000');
        $("#totvolume").val(parseFloat(req['spillrate']));
//		$('#duration').val('');
//		$('#spillrate').val('');
        $('#totvolume').prop('disabled',false);
        $('#lblITV').css('color','#333333');
        $('#lblCDUR,#lblCSPR').css('color','lightgray');		
    } else if(req['spillType']=='2'){
//		$("#totvolume").val('');
        $("#duration").val(parseInt(req['duration']));
        $('#spillrate').val(req['spillrate']);
        $('#duration,#spillrate').prop('disabled',false);
        //$('#totvolume').val('0');
        $('#totvolume').prop('disabled',true);
        $('#lblITV').css('color','lightgray');
        $('#lblCDUR,#lblCSPR').css('color','#333333');
    }
	
    // Advanced info
    $('input[name=stokes][value=' + parseInt(req['var_02']) + ']').prop('checked',true);  // stokes 
    //  "var_03":par3, // slider
    $('#slider').slider('value', parseInt(req['var_03']));
    $('#hDiff').val(parseFloat(req['var_10']));
    $('#oParc').val(parseFloat(req['var_14']));
    $('#eRate').val(parseFloat(req['var_19']));
    $('#dRate').val(parseFloat(req['var_29']));
    $('#tRate').val(parseFloat(req['var_39']));
	
    if($("#Ov0").is(':checked')) updateEnvFields();
	
    if (oldrId)
        $("#id_"+oldrId).children('legend').css({"background-color":"#ffffff"});
    oldrId=rId;
	
    $("#id_"+rId).children('legend').css({"background-color":"#dedede"});
    //console.log("res: ",res[0]);
    //console.log("req: ",req);
    // requestId
    requestId = res[0].correlationId;
    // start position
	
    // SELECTOR
    var selector = req.selector; 
    if (typeof selector == "undefined") selector = "witoil"; // legacy
//	var sel_checked = $("input:radio[name='selector']:checked");
//	sel_checked.removeAttr("checked");
    $("input:radio[name='selector']").removeAttr("checked");
    $("input:radio[name='selector'][value="+selector+"]").attr("checked","checked");
    $("input:radio[name='selector'][value="+selector+"]").click();
    switch (selector) {
      case "uncertainty": // UNCERTAINTY
            disableSimResults("witoil");
            enableSimResults("uncertainty");
      	
            $("#tactic_div").slideUp(function() {
            $("#uncert_div").slideDown();
            });
      	
            // display
            $("#oilinfo-submenu").slideUp("slow", function() {
        $("#uncert-submenu").slideDown();
        });
      	
            var uncert_type = req.uncert_type;
            $("#uncert_type").selectpicker("val",uncert_type);
      	
            if (uncert_type == "time") { // TIME
            } 
            else if (uncert_type == "position") { // POSITION
            $("input:radio[name='uncert_position']").removeAttr("checked");
            $("input:radio[name='uncert_position'][value="+req.hex+"]").attr("checked","checked");
            $("input:radio[name='uncert_position'][value="+req.hex+"]").click();
            $("#uncert_radius").val(req.uncert_radius);	
        }
            break;
      case "tactic": // TACTIC
            $("#uncert_div").slideUp(function() {
              $("#tactic_div").slideDown();
              });
            break;
    case "witoil":
      default: // none
            disableSimResults("uncertainty");
            enableSimResults("witoil");
 	
            $("#uncert_div").slideUp();
              $("#tactic_div").slideUp();
 
            // display
        $("#uncert-submenu").slideUp("slow", function() {
            $("#oilinfo-submenu").slideDown();
        });
    	
        $('#timepanel').show();
        $('#oilColorpalette').show();
            break;
     }
     

    */



    setLanguage(language: any, gui: boolean = true) {
        let val
        if (gui) val = language
        else val = language
        this.translate.use(val);
        let found = this.languages.filter(function (item) { return item.value === val })
        this.curr_lang = found[0]
    }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts